import { Button, Popover, Stack, Tooltip } from "@mantine/core";
import PopOver from "../../../../../components/View/PopOver";
import {
  IconChevronDown,
  IconChevronLeft,
  IconUserX,
} from "@tabler/icons-react";
import { useLanguage } from "../../../../../stores/LanguageStore";
import BlacklistDestination from "./BlacklistDestination";

const TableFilterToBlacklist = ({
  id,
  onFinish,
  selectedIds,
  filter,
  filterResultNumber,
  total,
}) => {
  const lang = useLanguage((s) => s.language);

  return (
    <PopOver
      opener={(handleOpen, ref) => (
        <Button
          className="to-blue"
          variant="light"
          justify="start"
          ref={ref}
          rightSection={<IconChevronDown size={16} />}
          leftSection={<IconUserX size={18} />}
          styles={{
            label: {
              marginRight: "auto",
            },
          }}
          onClick={handleOpen}
          color="red"
        >
          {lang.contact_lists.to_blacklist.label}
        </Button>
      )}
      popoverChildren={(handleClose) => (
        <Stack gap={"xs"}>
          <Popover
            zIndex={200}
            position="left"
            offset={0}
            shadow="md"
            withArrow
            keepMounted
          >
            <Popover.Target>
              <Tooltip
                label={lang.contact_lists.delete_contacts.no_filter}
                disabled={
                  filter?.items?.length > 0 ||
                  filter.quickFilterValues.filter(Boolean).length > 0
                }
              >
                <Button
                  disabled={
                    !filter ||
                    (filter?.items?.length < 1 &&
                      filter.quickFilterValues.filter(Boolean).length < 1)
                  }
                  variant="subtle"
                  size="sm"
                  color="red"
                  justify="start"
                  leftSection={<IconChevronLeft size={16} />}
                >
                  {lang.contact_lists.to_blacklist.filter}{" "}
                  {filter?.items?.length > 0 ||
                  filter.quickFilterValues.filter(Boolean).length > 0
                    ? `( ${filterResultNumber} )`
                    : ""}
                </Button>
              </Tooltip>
            </Popover.Target>
            <Popover.Dropdown>
              <BlacklistDestination
                handleClose={handleClose}
                filter={filter}
                id={id}
                onFinish={onFinish}
                selectedIds={selectedIds}
                type={"filter"}
                label={lang.contact_lists.content.copy_selection.success}
              />
            </Popover.Dropdown>
          </Popover>
          <Popover
            zIndex={200}
            keepMounted
            position="left"
            offset={0}
            shadow="md"
            withArrow
          >
            <Popover.Target>
              <Tooltip
                label={lang.contact_lists.delete_contacts.no_selection}
                disabled={selectedIds?.length > 0}
              >
                <Button
                  leftSection={<IconChevronLeft size={16} />}
                  disabled={!selectedIds || selectedIds?.length < 1}
                  variant="subtle"
                  size="sm"
                  color="red"
                  justify="start"
                >
                  {lang.contact_lists.to_blacklist.selection}{" "}
                  {selectedIds?.length > 0 ? `( ${selectedIds.length} )` : ""}
                </Button>
              </Tooltip>
            </Popover.Target>
            <Popover.Dropdown>
              <BlacklistDestination
                handleClose={handleClose}
                filter={filter}
                id={id}
                onFinish={onFinish}
                selectedIds={selectedIds}
                type={"selection"}
                label={lang.contact_lists.content.copy_selection.copy_selection}
              />
            </Popover.Dropdown>
          </Popover>

          <Popover
            zIndex={200}
            position="left"
            offset={0}
            shadow="md"
            withArrow
            keepMounted
          >
            <Popover.Target>
              <Tooltip
                label={lang.contact_lists.delete_contacts.no_selection}
                disabled={selectedIds?.length > 0}
              >
                <Button
                  leftSection={<IconChevronLeft size={16} />}
                  disabled={!selectedIds || selectedIds?.length < 1}
                  variant="subtle"
                  size="sm"
                  color="red"
                  justify="start"
                >
                  {lang.contact_lists.to_blacklist.selection_inverse}{" "}
                  {selectedIds?.length > 0
                    ? `( ${filterResultNumber - selectedIds.length} )`
                    : ""}
                </Button>
              </Tooltip>
            </Popover.Target>
            <Popover.Dropdown>
              <BlacklistDestination
                handleClose={handleClose}
                filter={filter}
                id={id}
                onFinish={onFinish}
                selectedIds={selectedIds}
                type={"selection_inverse"}
                label={
                  lang.contact_lists.content.copy_selection
                    .copy_all_but_selection
                }
              />
            </Popover.Dropdown>
          </Popover>

          <Popover
            zIndex={200}
            position="left"
            offset={0}
            shadow="md"
            withArrow
            keepMounted
          >
            <Popover.Target>
              <Tooltip
                label={lang.contact_lists.content.copy_selection.copy_all}
              >
                <Button
                  leftSection={<IconChevronLeft size={16} />}
                  variant="subtle"
                  size="sm"
                  color="red"
                  justify="start"
                >
                  {lang.contact_lists.to_blacklist.all_list} ({total})
                </Button>
              </Tooltip>
            </Popover.Target>
            <Popover.Dropdown>
              <BlacklistDestination
                handleClose={handleClose}
                filter={filter}
                id={id}
                onFinish={onFinish}
                selectedIds={selectedIds}
                type={"all"}
                label={lang.contact_lists.content.copy_selection.copy_all}
              />
            </Popover.Dropdown>
          </Popover>
        </Stack>
      )}
    />
  );
};

export default TableFilterToBlacklist;
